export default "__VITE_ASSET__BmKVA8Kp__"